import { render, staticRenderFns } from "./FeedbackCard.vue?vue&type=template&id=ee220d48&scoped=true&"
import script from "./FeedbackCard.vue?vue&type=script&lang=js&"
export * from "./FeedbackCard.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackCard.vue?vue&type=style&index=0&id=ee220d48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee220d48",
  null
  
)

export default component.exports